import { useSelector } from 'react-redux';
import { isVT911CoreEnabled } from '@rsos/reduxDataStore/src/features/selectors/videoTo911Selectors';
import { RootState } from '../app';

const useIsVT911CoreEnabled = () => {
  return useSelector((state: RootState) => isVT911CoreEnabled(state));
};

export default useIsVT911CoreEnabled;
